import React from 'react';
import atoms from 'ctsutheme/components/atoms';
import { FormViewContent } from 'components/FormViewContent';
import PropTypes from 'prop-types';
import { GetEmptyValue } from 'components';

const { Divider } = atoms;

const ViewContact = ({ data: { name, phone, email } }) => (
  <>
    <FormViewContent
      primaryText="Name"
      name="name"
      secondaryText={<GetEmptyValue value={name} />}
    />
    <Divider />
    <FormViewContent
      primaryText="Phone"
      name="phone"
      secondaryText={<GetEmptyValue value={phone} />}
    />
    <Divider />
    <FormViewContent
      primaryText="Email"
      name="email"
      secondaryText={<GetEmptyValue value={email} />}
    />
  </>
);

ViewContact.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object])
};

ViewContact.defaultProps = {
  data: null
};

export default ViewContact;
